import { FlowType } from '@jerry-serverless/types';

import { StepCategory, type AppData } from '../../../types/app_data';
import { stackStepQueryParams } from '../../common/step_stack';
import { excludeFromProgressCalculation } from '../../common/addcars';

// List of adding car steps for /policy flow (cars & drivers on same page).
export const GarageOnlyAddCarStepsBeforeOnboardingSteps = [
  {
    id: 'addCarYear',
    pathname: '/addcaryear',
    queryParams: stackStepQueryParams, // addCarYearQueryParams,
    excludeFromProgressCalculation,
    canShow: (appData) => {
      return true;
    },
    hasData: () => true,
    hasOwnData: (appData: AppData) => {
      if (appData.signupParams?.needNNOInsurance) {
        return true;
      }
      if (appData.initialCarAddCarByVin) {
        return true;
      }

      return appData.addingNewCar ? !!appData.addingNewCar.car.year : !!appData.signupParams?.initialCar?.year;
    },
    category: () => StepCategory.GarageOnlyCars,
  },
  {
    id: 'addCarMake',
    pathname: '/addcarmake',
    queryParams: stackStepQueryParams,
    excludeFromProgressCalculation,
    canShow: (appData) => {
      if (appData.initialCarAddCarByVin) {
        return false;
      }
      return true;
    },
    hasData: () => true,
    hasOwnData: (appData: AppData) =>
      !!(
        appData.initialCarAddCarByVin ||
        (appData.addingNewCar ? appData.addingNewCar.car.make : appData.signupParams?.initialCar?.make)
      ),

    category: () => StepCategory.GarageOnlyCars,
  },
  {
    id: 'addCarModel',
    pathname: '/addcarmodel',
    queryParams: stackStepQueryParams,
    excludeFromProgressCalculation,
    canShow: (appData) => {
      if (appData.initialCarAddCarByVin) {
        return false;
      }

      return true;
    },
    hasData: () => true,
    hasOwnData: (appData: AppData) =>
      !!(
        appData.initialCarAddCarByVin ||
        (appData.addingNewCar ? appData.addingNewCar.car.model : appData.signupParams?.initialCar?.model)
      ),
    category: () => StepCategory.GarageOnlyCars,
  },
  {
    id: 'addCarSubmodel',
    pathname: '/addcarsubmodel',
    queryParams: stackStepQueryParams,
    excludeFromProgressCalculation,
    canShow: (appData) => {
      if (appData.initialCarAddCarByVin) {
        return false;
      }
      if (
        appData.signupParams?.initialCar?.additionalInfo?.isInitialCarDefaultTrim ||
        appData.addingNewCar?.car.additionalInfo?.isInitialCarDefaultTrim
      ) {
        return false;
      }
      return true;
    },
    hasData: () => true,
    hasOwnData: (appData: AppData) =>
      !!(
        appData.initialCarAddCarByVin ||
        (appData.addingNewCar ? appData.addingNewCar.car.partialVin : appData.signupParams?.initialCar?.partialVin)
      ),
    category: () => StepCategory.GarageOnlyCars,
  },
  {
    id: 'addCarVin',
    pathname: '/addcarvin',
    queryParams: stackStepQueryParams,
    excludeFromProgressCalculation,
    canShow: (appData) => {
      return !!appData.initialCarAddCarByVin;
    },
    hasData: () => true,
    hasOwnData: (appData: AppData) =>
      appData.addingNewCar ? !!appData.addingNewCar.car.vin : !!appData.signupParams?.initialCar?.vin,
    category: () => StepCategory.GarageOnlyCars,
  },
];

export const GarageOnlyAddCarMileageReminderStep = {
  id: 'garageonlyaddcarmileagereminder',
  pathname: '/garageonlyaddcarmileagereminder',
  queryParams: stackStepQueryParams,
  excludeFromProgressCalculation,
  canShow: (appData) => {
    return !!appData.maintenanceAccepted;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !!appData.addedInitialCarMileage || true,
  category: () => StepCategory.GarageOnlyServices,
};

export const GarageOnlyAddCarMileageValueStep = {
  id: 'garageonlyaddcarmileagevalue',
  pathname: '/garageonlyaddcarmileagevalue',
  queryParams: stackStepQueryParams,
  excludeFromProgressCalculation,
  canShow: (appData) => {
    // If mileage is already added, skip this step
    return appData.garageOnlyFlowPageTempData?.carValueAccepted && !appData.addedInitialCarMileage;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !!appData.addedInitialCarMileage || true,
  category: (appData: AppData) =>
    appData.flowType && [FlowType.CarValue, FlowType.CarRecall, FlowType.Maintenance].includes(appData.flowType)
      ? StepCategory.GarageOnlyDriving
      : StepCategory.GarageOnlyServices,
};
